import React, { useState } from 'react';
import axios from 'axios';

const CallElevenLabsTwilio = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isCalling, setIsCalling] = useState(false);

  const handleInputChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const validatePhoneNumber = (number) => {
    // Rimuove tutti gli spazi
    let cleanedNumber = number.replace(/\s+/g, '');

    // Aggiunge il prefisso +39 se non è presente
    if (!cleanedNumber.startsWith('+39')) {
      cleanedNumber = '+39' + cleanedNumber;
    }

    // Controlla che il numero abbia esattamente 11 cifre dopo il prefisso
    if (cleanedNumber.length !== 13) {
      alert('Il numero di telefono deve avere 11 cifre dopo il prefisso +39.');
      return null;
    }

    return cleanedNumber;
  };

  const makeRequest = async () => {
    const validNumber = validatePhoneNumber(phoneNumber);
    if (!validNumber) return;

    try {
      const response = await axios.post('https://twilio-11labs-call-agent-production.up.railway.app/outbound-call', {
      //const response = await axios.post('https://e6bd-217-138-208-141.ngrok-free.app/outbound-call', {
        number: validNumber,
        prompt: 'Ciao, come posso aiutarti oggi?',
        type: 'lara',
      });
      console.log('Risposta ricevuta:', response.data);
      setIsCalling(true);
      setPhoneNumber('');
      window.alert('L\'agente ti sta chiamando...');
    } catch (error) {
      console.error('Errore nella richiesta:', error.response?.data || error.message);
    }
  };

  return (
    <div className="elevenlabs-container">
      <h2 className="title">Avvia una chiamata</h2>
      <input
        type="text"
        value={phoneNumber}
        onChange={handleInputChange}
        placeholder="Inserisci il tuo numero di telefono"
        className="input-field"
      />
      <button onClick={makeRequest} disabled={isCalling} className="start-button">
        {isCalling ? 'Chiamata in corso...' : 'Avvia Chiamata'}
      </button>
      <h4>Inserisci il numero in questo formato: +393513257290</h4>
    </div>
  );
};

export default CallElevenLabsTwilio;
